import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { utilityService } from 'app/sharedcomponents/commonservice/utility.service';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-google-autocomplete',
  templateUrl: './google-autocomplete.component.html',
  styleUrls: ['./google-autocomplete.component.css']
})
export class GoogleAutocompleteComponent implements OnInit, ModalComponent<CustomModalContext> {
  model: any = {};
  context: CustomModalContext;
  modalData: any;
  constructor(public dialog: DialogRef<CustomModalContext>, public domSanitizer: DomSanitizer, public translate: TranslateService, public router: Router, public utilserv: utilityService) {
    this.modalData = this.dialog.context.modalData;
    this.dialog.context.modalData.next = {};
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  ngOnInit() {}
  // Function will intitated Country List and Save on a session variable going forward will use this for getting Country related information
  closePopup() {
    this.dialog.close();
  }

  AutoCompleteCallback(place: any) {
    let addressData: any = {};
    let componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      country: 'long_name',
      postal_code: 'short_name'
    };
    if (place.data == undefined) {
      return false;
    }
    let data = place.data.address_components;
    for (var i = 0; i < data.length; i++) {
      var addressType = data[i].types[0];
      if (componentForm[addressType]) {
        switch (addressType) {
          case 'street_number':
            addressData.address1 = data[i].long_name;
            break;
          case 'route':
            addressData.address2 = data[i].long_name;
            break;
          case 'locality':
            addressData.city = data[i].long_name;
            break;
          case 'administrative_area_level_1':
            addressData.stateName = data[i].long_name;
            addressData.stateCode = data[i].short_name;
            break;
          case 'country':
            addressData.countryCode = data[i].short_name;
            addressData.countryName = data[i].long_name;
            break;
          case 'postal_code':
            addressData.zipcode = data[i].long_name;
            break;
          default:
            break;
        }
      }
    }

    this.model.address = this.utilserv.getObjectText(addressData.address1) + ' ' + this.utilserv.getObjectText(addressData.address2);
    this.model.city = this.utilserv.getObjectText(addressData.city);
    this.model.state = this.utilserv.getObjectText(addressData.stateCode);
    this.model.stateName = this.utilserv.getObjectText(addressData.stateName);
    this.model.zipcode = this.utilserv.getObjectText(addressData.zipcode);

    this.dialog.context.modalData.addressData = addressData;
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/countrylist/google-autocomplete/google-autocomplete.component.ts